import { MessageCircle } from "lucide-react";
import { waLink } from "../../lib/brand";

export const WhatsAppFab = () => {
  return (
    <a
      href={waLink()}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-fab"
      className="fixed bottom-6 right-6 z-50 group"
      aria-label="Chat on WhatsApp"
    >
      <span className="absolute -top-10 right-0 whitespace-nowrap bg-zinc-950 text-white text-[10px] tracking-[0.3em] uppercase px-3 py-2 opacity-0 group-hover:opacity-100 transition-opacity">
        Chat with us
      </span>
      <span className="relative grid place-items-center h-14 w-14 lg:h-16 lg:w-16 rounded-full bg-[#25D366] text-white shadow-xl wa-pulse hover:brightness-95 transition-all">
        <MessageCircle className="h-6 w-6 lg:h-7 lg:w-7" strokeWidth={1.75} />
      </span>
    </a>
  );
};
